/**
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 域名地址
 * routerMode: 路由模式
 */

let PROXY_URL = {};   // 接口地址

let routerMode = 'hash';

let getUrl = function(name) {
  let url = window.location.href;
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = !url.split("?")[1] ? "" : url.split("?")[1].match(reg);
  if (!!r) return decodeURI(r[2]);
  return null;
}

let businessNo = getUrl("appChannel") || localStorage.getItem("appChannel") ||'xubei_m';    //  渠道号
console.log('businessNo =>', businessNo)

const APP_ID='wxe5fdc9f33a443b2c';

if (process.env.API_ENV == 'development'||process.env.API_ENV == 'test') {
   PROXY_URL = {
     domain:'shapp.xubei-test.com',
     goodsList: '//good-api.xubei-test.com/goods-api/goods/findGoodsList',
     goods: '//good-api.xubei-test.com/goods-api/goods',
     user: '//user-server.xubei-test.com',
     order: '//cloud-order-api.test.xubei.com',
     pay: '//pay-api.xubei-test.com',
     config: '//api8.xubei-test.com',
     codeport:'//passport-server.xubei-test.com',
     gameList:'//rest-api.xubei.com/appxb/appconfig/rentPage',
     listDetails:'//list.xubei-test.com/free_play',
     userApi:'//user-api.xubei-test.com/user-api',
     commonServer:"//common-server.xubei-test.com",
  };

} else{
  //线上环境
  PROXY_URL = {
    domain:'xzuhao.com',
    goodsList: '//good-solr.xubei.com/goods/findGoodsLists',
    goods: '//good-api.xubei.com/goods-api/goods',
    user: '//user-server.xubei.com',
    order: '//order-api.xubei.com',
    pay: '//pay-api.xubei.com',
    config: '//api8.xubei.com',
    codeport:'//passport-server.xubei.com',
    gameList:'//rest-api.xubei.com/appxb/appconfig/rentPage',
    listDetails:'//list.xubei.com/free_play',
    userApi:'//user-api.xubei.com/user-api',
    commonServer:"//common-server.xubei.com",
  };

  //测试环境
  // PROXY_URL = {
  //   goodsList: '//good-api.xubei-test.com/goods-api/goods/findGoodsList',
  //   goods: '//good-api.xubei-test.com/goods-api/goods',
  //   user: '//user-server.xubei-test.com',
  //   order: '//cloud-order-api.test.xubei.com',
  //   pay: '//pay-api.xubei-test.com',
  //   config: '//api8.xubei-test.com',
  //   codeport:'//passport-server.xubei-test.com',
  //   gameList:'//rest-api.xubei.com/appxb/appconfig/rentPage',
  //   listDetails:'//list.xubei-test.com/free_play',
  //   userApi:'//user-api.xubei-test.com/user-api'
  // };

  // 线上强制跳转https
  // var targetProtocol = "https:";
  // if (window.location.protocol != targetProtocol)
  // window.location.href = targetProtocol +
  // window.location.href.substring(window.location.protocol.length);
}

export {
  routerMode,
  PROXY_URL,
  businessNo,
  APP_ID
}



// WEBPACK FOOTER //
// ./src/config/env.js